import { render } from "./AdditionalInfo.vue?vue&type=template&id=7d97161a&ts=true"
import script from "./AdditionalInfo.vue?vue&type=script&lang=ts"
export * from "./AdditionalInfo.vue?vue&type=script&lang=ts"

import "./AdditionalInfo.vue?vue&type=style&index=0&id=7d97161a&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__